import {
  authIndependentMethods,
  AUTHORIZATION_STATE,
  UPDATE,
} from '@airgram/constants'

import {
  Composer,
  isError,
} from '@airgram/core'

const authMethods = [
  'checkAuthenticationBotToken',
  'checkAuthenticationCode',
  'checkAuthenticationPassword',
  'checkDatabaseEncryptionKey',
  'getAuthorizationState',
  'registerUser',
  'requestAuthenticationPasswordRecovery',
  'resendAuthenticationCode',
  'setAuthenticationPhoneNumber',
  'setOption',
  'setTdlibParameters',
];

export default class Auth {
  constructor(callbacks) {
    this._airgram = null;
    this.attempt = 0;
    this.maxAttempts = 3;
    this.invalidPhoneNumbers = new Set();
    this.deferred = {
      promise: new Promise(() => {
      }),
      resolve: () => {
      },
      reject: () => {
      },
    };
    this.store = null;
    this.authState = null;
    this.callbacks = callbacks;
    this.listeners = [];

    // Object.defineProperty(this, 'authState', {
    //     get() {
    //         return this.store.state.tg.auth.authState;
    //     },
    //     set(v) {
    //         this.store.dispatch('tg/auth/setValue', {
    //             key: 'authState',
    //             value: v,
    //         })
    //     }
    // })
  }

  get isAuthorized() {
    return !!(this.authState && this.authState._ === AUTHORIZATION_STATE.authorizationStateReady)
  }

  get airgram() {
    if (!this._airgram) {
      throw new Error('Airgram has not been initialized yet.')
    }
    return this._airgram;
  }

  middleware() {
    return Composer.compose([
      (ctx, next) => {
        if (!this._airgram) {
          this._airgram = ctx.airgram;
          this.store = ctx.airgram.config.context.$store;
          this._airgram.auth = {}
        }
        return next()
      },
      Composer.filter(ctx => !('update' in ctx) ||
        !ctx.update ||
        ctx.update._ !== UPDATE.updateAuthorizationState ||
        !this.handleUpdateState(ctx.$store, ctx.update),
      ),
      Composer.optional(
        ctx =>
          !this.isAuthorized &&
          !authMethods.includes(ctx._) &&
          !authIndependentMethods.includes(ctx._),
        // (_ctx, next) => this.login().then(next)
        () => {
        },
      ),
    ])
  }

  onChangeState(cb) {
    this.listeners.push(cb);
  }

  async handleUpdateState(store, {authorizationState}) {
    this.attempt = 0;
    this.authState = authorizationState;
    console.log(store);
    let promise = null;

    switch (authorizationState._) {
      case AUTHORIZATION_STATE.authorizationStateWaitPhoneNumber: {
        // if (this.isBot) {
        //     const token = await this.ask('token')
        //     promise = this.airgram.api.checkAuthenticationBotToken({ token })
        // }
        // break
        // store.dispatch('tg/auth/setValue', {
        //     key: 'authState',
        //     value: AUTHORIZATION_STATE.authorizationStateWaitPhoneNumber,
        // });
        console.log('NEED PHONE')
        promise = this.callbacks.phone(authorizationState);
        promise.then((phoneNumber) => this.airgram.api.setAuthenticationPhoneNumber({
          phoneNumber,
        }))
        // promise = this.askPhoneNumber().then((phoneNumber) => this.airgram.api.setAuthenticationPhoneNumber({
        //     phoneNumber
        // }))
        break;
      }
      case AUTHORIZATION_STATE.authorizationStateWaitCode: {
        promise = this.sendCode();
        break
      }
      case AUTHORIZATION_STATE.authorizationStateWaitRegistration: {
        // promise = this.registerUser();
        break
      }
      case AUTHORIZATION_STATE.authorizationStateWaitPassword: {
        // promise = this.checkAuthenticationPassword();
        break
      }
      case AUTHORIZATION_STATE.authorizationStateReady: {
        // this._airgram.api.logOut();
        this.callbacks.ready(authorizationState);
        if (this.deferred) {
          await this.deferred.resolve();
          this.deferred = null;
        }
        break
      }
      default: {
        return false
      }
    }

    return promise ? promise.then(({response}) => {
        console.log(response);
        if (isError(response)) {
          this.handleError(response);
          return false
        }
        return true
      }).catch((error) => this.fatalError(error))
      : true
  }

  async ask(title) {
    return new Promise((resolve, reject) => {
      const value = prompt(title);
      resolve(value);
    })
  }

  async askPhoneNumber() {
    return this.ask('phoneNumber')
      .then(async (phoneNumber) => {
        if (!phoneNumber) {
          throw new Error('Phone number is not defined')
        }
        if (this.invalidPhoneNumbers.has(phoneNumber) || !/^\+?\d{10,}$/.test(phoneNumber.trim())) {
          this.invalidPhoneNumbers.add(phoneNumber);
          delete this.answers.phoneNumber;
          throw new Error('Invalid phone number');
        }
        return phoneNumber;
      })
  }

  async login() {
    if (!this.deferred) {
      const deferred = {};
      deferred.promise = new Promise((resolve, reject) => {
        deferred.resolve = resolve;
        deferred.reject = reject;
      });
      this.deferred = deferred;
      if (!this.authState) {
        const {response: authState} = await this.airgram.api.getAuthorizationState();
        this.authState = authState || null
      }
    }
    return Promise.resolve(this.deferred ? this.deferred.promise : undefined);
  }

  async registerUser() {
    const firstName = await this.ask('firstName');
    if (!firstName) {
      throw new Error('First name can not be empty.')
    }

    return this.airgram.api.registerUser({
      firstName,
      lastName: (await this.ask('lastName')) || undefined,
    })
  }

  async sendCode() {
    const code = await this.callbacks.code();
    if (!code || !/^\d+$/.test(code)) {
      throw new Error('Invalid authorization code')
    }

    return this.airgram.api.checkAuthenticationCode({
      code,
    })
  }

  async checkAuthenticationPassword() {
    return this.airgram.api.checkAuthenticationPassword({
      password: await this.ask('password'),
    })
  }

  async handleError(error) {
    let promise = null;

    if (error.code === 429) {
      return this.fatalError(new Error(error.message))
    }

    switch (error.message) {
      case 'PHONE_NUMBER_INVALID': {
        console.log('asdasd');
        if (this.answers.phoneNumber) {
          this.invalidPhoneNumbers.add(this.answers.phoneNumber);
          delete this.answers.phoneNumber;
        }
        promise = this.askPhoneNumber()
          .then((phoneNumber) => this.airgram.api.setAuthenticationPhoneNumber({phoneNumber}))
        break;
      }
      case 'PHONE_CODE_EMPTY':
      case 'PHONE_CODE_EXPIRED':
      case 'PHONE_CODE_INVALID': {
        if (this.attempt < this.maxAttempts) {
          this.attempt += 1;
          promise = this.sendCode();
        } else {
          return this.fatalError(new Error('Exceeded the limit of failed attempts'))
        }
        break
      }
      case 'PASSWORD_HASH_INVALID': {
        if (this.attempt < this.maxAttempts) {
          this.attempt += 1;
          promise = this.checkAuthenticationPassword();
        } else {
          return this.fatalError(new Error('Exceeded the limit of failed attempts'))
        }
        break;
      }
      default: {
        return false
      }
    }

    return promise
      ? promise.then(({response}) => {
        if (isError(response)) {
          this.handleError(response);
          return false
        }
        return true
      }).catch((error) => this.fatalError(error))
      : true
  }

  async fatalError(error) {
    console.error(`[TGW Error] quit due an error: "${error.message}"`);
    if (this.airgram && this.airgram.provider.destroy) {
      await this.airgram.provider.destroy()
    }
    return false
  }
}
